// const dateOptions = [
//   {
//     label: 'Hoje',
//     value: 'Today',
//   },
//   {
//     label: 'Ontem',
//     value: 'Yesterday',
//   },
//   {
//     label: 'Últimos 7 Dias',
//     value: 'Last7Days',
//   },
//   {
//     label: 'Últimos 15 Dias',
//     value: 'Last15Days',
//   },
//   {
//     label: 'Últimos 30 Dias',
//     value: 'Last30Days',
//   },
// ]

// export { dateOptions }

export function getDateOptions(t: (key: string) => string) {
  return {
    dateOptions: [
      {
        label: t('Activities.Rebate.Historial.Today'),
        value: 'Today',
      },
      {
        label: t('Activities.Rebate.Historial.Yesterday'),
        value: 'Yesterday',
      },
      {
        label: t('Activities.Rebate.Historial.Last7Days'),
        value: 'Last7Days',
      },
      {
        label: t('Activities.Rebate.Historial.Last15Days'),
        value: 'Last15Days',
      },
      {
        label: t('Activities.Rebate.Historial.Last30Days'),
        value: 'Last30Days',
      },
    ]
  }
}